// Query Keys
export const QUERY_KEY_USER_MAPPING_LIST = 'user-mapping-list'
export const QUERY_KEY_USER_MAPPING_DETAIL = 'user-mapping-detail'

export const USER_MAPPING_LIST_QUERY_KEY = (params: (string | number)[]) =>
  [QUERY_KEY_USER_MAPPING_LIST, ...(params ? [params] : [])] as const

export enum UserMappingSource {
  MAPPED_ONLY = 'mapped_only',
  SYSTEM = 'system',
  TEAMWORK = 'teamwork',
}

export const GET_TEAMWORK_PAGINATION_LIMIT = 100
